import React from 'react';
import './card.css';
import profilecircle from '../../assets/images/profile-circle.png';
import Logo from '../../assets/images/Logo.png';
export default function Card(props) {
  // const widt = 296;
  const heig = 135;
  return (
    <div  style={{ height: `${heig}px` }} className='cardContainerLogos cardContainer'>
      <label htmlFor={'picturefile'}>
        <div
         
          className="imguploaded"
        >
          <div className="addLogo addProfileLogoo">
            <input
              type="file"
              name={'picturefile'}
              id={'picturefile'}
              onChange={(e)=>props?.handleChange(e)}
              accept=".png,.jpeg,.jpg"
            />
            <label htmlFor={'picturefile'}>
              <img
                htmlFor="picturefile"
                src={
                  !props.file
                    ? props.image
                      ? props.image
                      : Logo
                    : URL.createObjectURL(props.file)
                }
                alt=""
              />
              Add a Logo
            </label>
          </div>
          <div className="rejectButtonActive helpButton">
            <div className="navHelpButton">
              <img src={profilecircle} alt="" />
            </div>

            <div className="navButtonTitle">
              <p>Upload</p>
            </div>
          </div>
        </div>
      </label>
    </div>
  );
}
